import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, CreditCardIcon, LandmarkIcon, StarIcon } from 'lucide-react';
import { Button } from './ui';
export const Hero = () => {
  return <div className="relative pt-10 pb-16 md:pt-16 md:pb-24 px-4 overflow-hidden" data-id="element-57">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[500px] bg-primary/10 blur-[120px] rounded-full pointer-events-none" data-id="element-58"></div>

      <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-59">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-60">
          <p className="text-primary font-semibold tracking-wider text-sm md:text-base mb-4 uppercase" data-id="element-61"></p>
          <div className="inline-block bg-dark-card border border-dark-border rounded-full px-6 py-2 mb-8" data-id="element-62">
            <span className="text-gray-300 font-medium text-[14px]" data-id="element-63">
              🐾 KIT PROFESIONAL DEL CUIDADOR 360™{' '}
              <span className="text-gray-500" data-id="element-64">by Global Nova Pro</span>
            </span>
          </div>

          <h1 className="md:text-6xl lg:text-7xl font-black text-white mb-8 text-[32px]" data-id="element-65">
            Todo lo necesario para cuidar mascotas como un profesional.
          </h1>

          <div className="mb-10 flex justify-center" data-id="element-66">
            <img src="https://cdn.magicpatterns.com/uploads/7q4qy6koTnCao965gf8rHn/Diseno_sin_titulo_(1).png" alt="Kit Profesional del Cuidador 360" className="w-full max-w-xl object-contain drop-shadow-[0_20px_40px_rgba(139,92,246,0.2)]" data-id="element-67" />
          </div>

          <p className="md:text-2xl text-gray-300 mb-3 max-w-3xl mx-auto font-medium text-[16px]" data-id="element-68">
            El sistema N°1 para cuidadores en Argentina — Contratos, fichas,
            protocolos y más. Todo resuelto.
          </p>

          <p className="text-gray-400 text-sm md:text-base mb-6 font-medium" data-id="element-69">
            💡 100% PDF · ⚡ Acceso en 5 min · 🐶🐱 Perros y Gatos · 📋 Todo
            incluido
          </p>

          <div className="flex flex-col items-center gap-6" data-id="element-70">
            <Button size="xl" href="#pricing" className="animate-pulse-slow max-w-md w-full text-xl" data-id="element-71">
              🔥 QUIERO MI KIT PROFESIONAL AHORA
            </Button>

            <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm text-gray-400 font-medium" data-id="element-72">
              <span className="flex items-center gap-2" data-id="element-73">
                <ShieldCheckIcon size={18} className="text-primary" data-id="element-74" /> Garantía
                7 días
              </span>
              <span className="flex items-center gap-2" data-id="element-75">
                <CreditCardIcon size={18} className="text-primary" data-id="element-76" /> Pago
                seguro
              </span>
              <span className="flex items-center gap-2" data-id="element-77">
                <LandmarkIcon size={18} className="text-primary" data-id="element-78" /> Mercado Pago
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </div>;
};
export const SocialProof = () => {
  return <div className="border-y border-dark-border bg-dark-card/50 py-6" data-id="element-79">
      <div className="max-w-6xl mx-auto px-4" data-id="element-80">
        <div className="flex flex-wrap justify-center md:justify-between items-center gap-6 md:gap-4 text-center" data-id="element-81">
          <div className="w-full md:w-auto" data-id="element-82">
            <p className="text-2xl font-bold text-white" data-id="element-83">+200</p>
            <p className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-84">
              cuidadores confían
            </p>
          </div>
          <div className="hidden md:block w-px h-10 bg-dark-border" data-id="element-85"></div>
          <div className="w-full md:w-auto" data-id="element-86">
            <p className="text-2xl font-bold text-white" data-id="element-87">6</p>
            <p className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-88">
              Tomos listos
            </p>
          </div>
          <div className="hidden md:block w-px h-10 bg-dark-border" data-id="element-89"></div>
          <div className="w-full md:w-auto" data-id="element-90">
            <p className="text-2xl font-bold text-white" data-id="element-91">6</p>
            <p className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-92">
              Bonos incluidos
            </p>
          </div>
          <div className="hidden md:block w-px h-10 bg-dark-border" data-id="element-93"></div>
          <div className="w-full md:w-auto flex flex-col items-center" data-id="element-94">
            <div className="flex text-accent mb-1" data-id="element-95">
              {[...Array(5)].map((_, i) => <StarIcon key={i} size={20} fill="currentColor" data-id="element-96" />)}
            </div>
            <p className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-97">
              4.9/5 de valoración
            </p>
          </div>
        </div>
      </div>
    </div>;
};